import type {InputProps} from '@chakra-ui/react';
import {Input} from '@chakra-ui/react';
import type {FieldPath, FieldValues} from 'react-hook-form';
import {useController} from 'react-hook-form';

export type FieldInputProps<TName> = Omit<InputProps, 'name'> & {name: TName};

export const FieldInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  ...rest
}: FieldInputProps<TName>) => {
  const {field} = useController({
    name,
  });

  return <Input {...field} value={field.value || ``} {...rest} />;
};
